import React, { FC } from "react";
import { ISVG } from "types/ISVG";

const SberPaySVG: FC<ISVG> = ({width, height, className}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 373 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0.5" width="372" height="60" rx="24" fill="#3DC546" />
      <rect
        x="0.5"
        width="372"
        height="60"
        rx="24"
        fill="url(#paint0_radial_4062_530)"
        fillOpacity="0.91"
      />
      <rect
        x="0.5"
        width="372"
        height="60"
        rx="24"
        fill="url(#paint1_radial_4062_530)"
        fillOpacity="0.9"
      />
      <g clipPath="url(#clip0_4062_530)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M192.938 32.828C194.289 32.5636 195.669 32.4747 197.043 32.5637C197.484 34.8365 194.7 36.0873 192.885 35.2769C192.654 35.1666 192.459 34.9931 192.322 34.7764C192.185 34.5597 192.113 34.3087 192.113 34.0524C192.113 33.7962 192.185 33.5452 192.322 33.3285C192.459 33.1118 192.654 32.9383 192.885 32.828H192.938ZM178.332 23.5427C180.228 23.3905 182.135 23.5331 183.988 23.9656C184.637 24.3119 185.131 24.892 185.37 25.5885C185.609 26.2851 185.574 27.0463 185.274 27.7184C185.076 28.2292 184.741 28.6754 184.306 29.008C183.87 29.3407 183.352 29.5466 182.807 29.6036C181.319 29.7329 179.825 29.7742 178.332 29.727C178.332 27.6597 178.332 25.5983 178.332 23.5427ZM201.237 25.6217C202.998 29.7621 204.655 33.885 206.364 37.955C206.011 38.7479 205.765 39.717 204.848 40.087C204.501 40.1548 204.142 40.1458 203.798 40.0606C203.455 39.9754 203.133 39.816 202.858 39.5937C202.858 40.4922 202.858 41.3556 202.858 42.2718C203.374 42.5527 203.944 42.7214 204.53 42.7669C205.116 42.8124 205.705 42.7339 206.258 42.5361C207.356 41.8055 208.157 40.7053 208.513 39.4352C210.169 34.819 211.79 30.185 213.464 25.5864H210.469C209.5 28.3526 208.707 31.1894 207.685 33.9027C206.558 31.1542 205.5 28.3526 204.373 25.5864L201.237 25.6217ZM190.172 26.485C190.172 27.6831 190.172 28.8812 190.172 30.0088C190.801 29.1249 191.694 28.4619 192.722 28.114C193.75 27.766 194.861 27.7509 195.898 28.0707C196.973 28.4231 196.99 29.7093 197.043 30.6607C195.384 30.59 193.722 30.6607 192.075 30.8721C191.433 30.9455 190.83 31.2152 190.348 31.644C189.865 32.0729 189.527 32.6402 189.379 33.2685C189.166 34.0497 189.201 34.8776 189.479 35.6382C189.756 36.3988 190.263 37.0543 190.929 37.5145C191.996 38.0953 193.247 38.2362 194.415 37.907C195.584 37.5778 196.578 36.8045 197.184 35.7526C197.184 36.4691 197.184 37.1915 197.184 37.9197H199.862C199.862 34.9597 199.862 31.9997 199.862 29.1102C199.818 28.2992 199.505 27.5262 198.972 26.9134C198.439 26.3006 197.717 25.8832 196.92 25.7275C194.672 25.1671 192.296 25.4688 190.26 26.5732L190.172 26.485ZM162.721 21.9746C159.303 24.547 155.873 27.1017 152.432 29.6389C150.811 28.5817 149.155 27.5598 147.516 26.5203C147.516 27.7888 147.516 29.0575 147.516 30.326C149.172 31.3127 150.776 32.3698 152.397 33.4094C156.378 30.4846 160.325 27.5246 164.272 24.5998C163.81 23.7008 163.286 22.8354 162.704 22.0099L162.721 21.9746ZM175.248 20.7061C175.248 26.4382 175.248 32.1702 175.248 37.9023H178.261C178.261 36.1404 178.261 34.3785 178.261 32.6166C180.939 32.6166 183.847 32.8455 186.208 31.3302C187.279 30.4943 188.044 29.3268 188.382 28.0103C188.72 26.6938 188.612 25.3023 188.075 24.0535C187.649 23.1809 186.999 22.4372 186.191 21.8985C185.383 21.3598 184.446 21.0455 183.477 20.9878C180.723 20.7438 177.958 20.6673 175.196 20.7588L175.248 20.7061ZM139.499 29.6565C139.593 26.2858 140.975 23.0791 143.361 20.6964C145.747 18.3137 148.955 16.9363 152.326 16.8474C155.34 16.8713 158.263 17.8867 160.642 19.737L158.105 21.6397C156.68 20.6729 155.028 20.0916 153.311 19.9527C151.595 19.8137 149.871 20.1219 148.309 20.847C146.506 21.6991 144.995 23.0654 143.966 24.7738C142.938 26.4823 142.437 28.4566 142.527 30.4488C142.618 32.4411 143.295 34.3622 144.474 35.9705C145.653 37.5788 147.282 38.8025 149.155 39.4878C150.516 39.9762 151.968 40.1599 153.408 40.026C154.848 39.892 156.241 39.4437 157.488 38.7127C159.026 37.78 160.293 36.4618 161.165 34.8889C162.036 33.3159 162.482 31.5427 162.457 29.7447C163.373 29.0223 164.325 28.3526 165.241 27.6303C165.719 30.3586 165.33 33.1681 164.131 35.6646C163.186 37.6671 161.747 39.3966 159.95 40.691C158.154 41.9853 156.058 42.802 153.859 43.0646C151.298 43.3565 148.71 42.839 146.459 41.5846C144.31 40.4331 142.523 38.7089 141.294 36.6035C140.066 34.498 139.445 32.0935 139.499 29.6565Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_4062_530"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(352.5 -6.45543e-06) rotate(164.796) scale(148.705 112.233)"
        >
          <stop stopColor="#11A2F4" />
          <stop offset="1" stopColor="#00DDFB" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4062_530"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.5 52.5) rotate(-11.5834) scale(82.1736 88.458)"
        >
          <stop stopColor="#D6CC11" />
          <stop offset="1" stopColor="#F7EB00" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_4062_530">
          <rect
            width="74"
            height="26.27"
            fill="white"
            transform="translate(139.5 16.865)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SberPaySVG;
